import {DefaultFieldWindow} from "./DefaultFieldWindow";
import {Form as FormEntity} from "../Form";
import {checkbox, containerfield, Fieldset} from "@intermesh/goui";

import {t} from "../Translate";

export class DateFieldWindow extends DefaultFieldWindow {
	constructor(formEntity:FormEntity, type:string) {
		super(formEntity, type);

		const fs = this.generalTab.items.get(0) as Fieldset

		fs.items.add(
			containerfield({name: "options"},
				checkbox({
					type: "switch",
					name: "withTime",
					label: t("With time")
				})
			)
		)
	}
}